import React from "react";
import Step1 from "../steps/section-1/step-1";
import Step2 from "../steps/section-1/step-2";

function TeamReportsSection1({ step = 1, rank_name = "" }) {
  if (step === 1) {
    return <Step1 rank_name={rank_name} />;
  }

  if (step === 2) {
    return <Step2 />;
  }

  return null;
}

export default TeamReportsSection1;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-1.js